var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .833a9.167 9.167 0 11-.001 18.334A9.167 9.167 0 0110 .833zm-.834 11.668L10 14.166l.833-1.665V8.334H9.166V12.5zM10 5.834A.834.834 0 1010 7.5a.834.834 0 000-1.668z",
    fill: "#fff"
  })));
}

export default SvgCircleInfoIcon;